//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Color",1,0],[0,"ColorOption",1,0],[0,"ColorPickerFlowLineColor",1,0],[0,"CreationType",1,0],[0,"DefineFlowLineStyle",1,0],[0,"DrawFlowLinePerObject",1,0],[0,"LineFontFlowLineFont",1,0],[0,"LineWidthFlowLineWidth",1,0],[1,"MotionObject",0,"SelectNXObjectList",0],[0,"Name",1,0],[0,"ShowFlowLineInSimulation",1,0]],[[["pos","startTime","duration","distance","spin","angle","dir"],"InsertStep",{},7,0],[["steps","mirror_time"],"MirrorSteps",{R_:{newSteps:""}},2,0],[["pos","split_time"],"SplitStep",{R_:{splited:''}},2,0],[["pos"],"DeleteStep",{},1,0],[["pos","name"],"SetStepName",{},2,0],[["pos","start_time"],"SetStepStartTime",{},2,0],[["pos","duration"],"SetStepDuration",{},2,0],[["pos","distance"],"SetStepDistance",{},2,0],[["pos","angle"],"SetStepAngle",{},2,0],[["pos","spin"],"SetStepSpin",{},2,0],[["pos","dir"],"SetStepDirection",{},2,0],[["pos","useOrigin"],"SetStepUseOrigin",{},2,0],[["pos","rotation"],"SetStepTargetPosition",{},2,0],[[],"GetStepCount",{R_:{count:''}},0,0]],[]];
SPLM.AnimationDesigner.AnimatedExplodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.AnimatedExplodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.AnimatedExplodeBuilder.CreationTypes = Object.freeze({
    "Combine" : "Combine", "Separate" : "Separate"});

SPLM.AnimationDesigner.AnimatedExplodeBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "AutomaticColor" : "AutomaticColor", "NoColor" : "NoColor"});

export default SPLM;